<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	//Services
	import { postReq } from '../../../services/http';
	//Helpers
	import { real_id } from '../../../helpers/interface_helpers';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Checkbox, Button } from '@Shelly/shelly-design-system';
	//Types
	import type { SettingRequest } from '../../../types/requests/settings/setting';
	import type { Device } from '../../../types/Device';

	$: settingsStore = getDeviceSettings(id);
	export let device: Device;

	const id = real_id(device.id),
		settings = $settingsStore;
	let checked = settings.external_power,
		waitForResponse = false;

	const save = async () => {
		waitForResponse = true;
		const res: SettingRequest = await postReq(`/device/${device.category}/settings/power_supply`, {
			id,
			enabled: Number(checked),
		});
		onSettingsResponse(res, device);
		waitForResponse = false;
	};
</script>

<Checkbox size="m" class="mb-s" bind:checked id="checkbox-8jtv4ni"
	>{$format('external_power_supply_enable', {
		default: 'Enable/Disable external power supply.',
	})}</Checkbox
>

<Button size="m" width="full" loading={waitForResponse} on:click={save}
	>{$format('button_save', { default: 'Save' })}</Button
>
